import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { apiFetch } from "@/lib/api";

import type { RelationshipRequest } from "../api";

/** Re-checks one approved request against live Cinch data; flips it to
 *  Applied when the graph matches. */
export function VerifyButton({ requestId }: { requestId: string }) {
  const qc = useQueryClient();
  const verify = useMutation({
    mutationFn: () =>
      apiFetch<RelationshipRequest>(`/parent-companies/requests/${requestId}/verify`, {
        method: "POST",
      }),
    onSuccess: (r) => {
      void qc.invalidateQueries({ queryKey: ["parent_companies", "requests"] });
      void qc.invalidateQueries({ queryKey: ["parent_companies", "changelog"] });
      if (r.applied_at) {
        toast.success("Verified — the change is live in Cinch");
        void qc.invalidateQueries({ queryKey: ["parent_companies", "roster"] });
      } else {
        toast.info("Not in Cinch yet — apply it in the admin first");
      }
    },
    onError: (e) => toast.error(e.message),
  });
  return (
    <Button
      size="sm"
      variant="outline"
      disabled={verify.isPending}
      onClick={() => verify.mutate()}
    >
      {verify.isPending ? "Checking…" : "Verify in Cinch"}
    </Button>
  );
}
